// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {
	request
} from "./common/request"
import api from "./common/api"
import * as echarts from "echarts"
import btnPermissions from "./utils/btnPermissions.js"

Vue.use(ElementUI);
locale.use(lang)

Vue.config.productionTip = false
Vue.use(VueAxios, axios);

Vue.prototype.$request = request;
Vue.prototype.$api = api;
Vue.prototype.$echarts = echarts

//路由前置操作
router.beforeEach((to, from, next) => {
  //如果访问的是admin的路由，判断管理员有没有登入
  if (to.matched[0].path == "") {
    if (to.path == "/Login") {  //如果是登入页面，则直接访问
      next();
    }else{
      let token = sessionStorage.getItem("token");
      if(token==null){
        next({path:"/Login"})
      }else{
		  let token = sessionStorage.getItem("token");
		  axios.defaults.headers.common['token'] = token;
        next();
      }
    }
  }else{
    //其他模塊路由访问
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js